module.exports = __webpack_public_path__ + "static/img/logo.c5e9d751.png";